"use strict";

var _classCallCheck = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _get = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/get");

var _inherits = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/inherits");

var conversions = require("webidl-conversions");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var resourceLoader = require("../../browser/resource-loader");

var _require = require("../../utils"),
    Canvas = _require.Canvas,
    reflectURLAttribute = _require.reflectURLAttribute;

var HTMLImageElementImpl =
/*#__PURE__*/
function (_HTMLElementImpl) {
  _inherits(HTMLImageElementImpl, _HTMLElementImpl);

  function HTMLImageElementImpl() {
    _classCallCheck(this, HTMLImageElementImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(HTMLImageElementImpl).apply(this, arguments));
  }

  _createClass(HTMLImageElementImpl, [{
    key: "_attrModified",
    value: function _attrModified(name, value, oldVal) {
      var _this = this;

      if (name === "src" && value !== oldVal) {
        var document = this._ownerDocument;

        if (Canvas && document.implementation._hasFeature("FetchExternalResources", "img")) {
          var error;

          if (!this._image) {
            this._image = new Canvas.Image(); // Install an error handler that just remembers the error. It is then
            // thrown in the callback of resourceLoader.load() below.

            this._image.onerror = function (err) {
              error = err;
            };
          }

          this._currentSrc = null;

          if (this.hasAttribute("src")) {
            resourceLoader.load(this, this.src, {}, function (data, url, response) {
              if (response && response.statusCode !== undefined && response.statusCode !== 200) {
                throw new Error("Status code: " + response.statusCode);
              }

              error = null;
              _this._image.source = data;

              if (error) {
                throw new Error(error);
              }

              _this._currentSrc = value;
            });
          } else {
            this._image.source = undefined;
          }
        }
      }

      _get(_getPrototypeOf(HTMLImageElementImpl.prototype), "_attrModified", this).call(this, name, value, oldVal);
    }
  }, {
    key: "_accept",
    get: function get() {
      return "image/png,image/*;q=0.8,*/*;q=0.5";
    }
  }, {
    key: "src",
    get: function get() {
      return reflectURLAttribute(this, "src");
    },
    set: function set(value) {
      this.setAttribute("src", value);
    }
  }, {
    key: "srcset",
    get: function get() {
      return conversions.USVString(this.getAttribute("srcset"));
    },
    set: function set(value) {
      this.setAttribute("srcset", value);
    }
  }, {
    key: "height",
    get: function get() {
      // Just like on browsers, if no width / height is defined, we fall back on the
      // dimensions of the internal image data.
      return this.hasAttribute("height") ? conversions["unsigned long"](this.getAttribute("height")) : this.naturalHeight;
    },
    set: function set(V) {
      this.setAttribute("height", String(V));
    }
  }, {
    key: "width",
    get: function get() {
      return this.hasAttribute("width") ? conversions["unsigned long"](this.getAttribute("width")) : this.naturalWidth;
    },
    set: function set(V) {
      this.setAttribute("width", String(V));
    }
  }, {
    key: "naturalHeight",
    get: function get() {
      return this._image ? this._image.height : 0;
    }
  }, {
    key: "naturalWidth",
    get: function get() {
      return this._image ? this._image.width : 0;
    }
  }, {
    key: "complete",
    get: function get() {
      return Boolean(this._image && this._image.complete);
    }
  }, {
    key: "currentSrc",
    get: function get() {
      return this._currentSrc || "";
    }
  }, {
    key: "lowsrc",
    get: function get() {
      return reflectURLAttribute(this, "lowsrc");
    },
    set: function set(value) {
      this.setAttribute("lowsrc", value);
    }
  }, {
    key: "longDesc",
    get: function get() {
      return reflectURLAttribute(this, "longdesc");
    },
    set: function set(value) {
      this.setAttribute("longdesc", value);
    }
  }]);

  return HTMLImageElementImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLImageElementImpl
};